import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, label, ...props }, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label className=" font-extrabold text-[22px] text-primary leading-[1.4] mb-1 block">
          {label}
        </label>
      )}
      <input
        type={type}
        className={cn(
          "flex h-[64px] w-full border-b border-[#ababab] bg-transparent px-2 py-2 font-extrabold text-[20px] text-black placeholder:text-[#9e9e9e] placeholder:normal-case focus-visible:outline-none focus-visible:border-black disabled:cursor-not-allowed disabled:opacity-50 transition-colors",
          className
        )}
        ref={ref}
        {...props}
      />
    </div>
  )
})
Input.displayName = "Input"

export { Input }
